import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useState } from 'react'

import styles from './AlertBox.module.sass'

const AlertBox = ({ items, type, className }) => {
	const [currentItem, setCurrentItem] = useState(0)

	const item = items[currentItem]

	const incrementItem = () => {
		if (currentItem + 1 === items.length) return
		setCurrentItem(currentItem + 1)
	}

	const decrementItem = () => {
		if (currentItem === 0) return
		setCurrentItem(currentItem - 1)
	}

	return (
		<HStack
			className={`${styles['root']} ${styles[`--${type}`]} ${
				className || ''
			}`}
		>
			<HStack>
				<Icon
					className={styles['status-icon']}
					width='20px'
					height='20px'
					name={type}
				/>
				<VStack
					className={`${styles['content']} ${
						!item?.title ? styles['--without-title'] : null
					}`}
				>
					{item?.title ? <h5>{item?.title}</h5> : null}
					{item?.content ? (
						item.content
					) : (
						<small>{item?.text || '-'}</small>
					)}
				</VStack>
			</HStack>
			{items.length > 1 && (
				<HStack className={styles['pagination']}>
					<Icon
						onClick={() => decrementItem()}
						className={
							styles[`${currentItem === 0 ? 'disabled' : ''}`]
						}
						width='14px'
						height='14px'
						name={'chevron'}
					/>
					<small>
						{currentItem + 1}/{items.length}
					</small>
					<Icon
						onClick={() => incrementItem()}
						className={
							styles[
								`${
									currentItem + 1 === items.length
										? 'disabled'
										: ''
								}`
							]
						}
						width='14px'
						height='14px'
						name={'chevron'}
					/>
				</HStack>
			)}
		</HStack>
	)
}

export default AlertBox
